// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"368":"046926f6","624":"d16c5801","738":"10ef67e6","801":"98030aca"}[chunkId] + ".css";
};